/* eslint-disable max-len */
export const SUPPORT_CENTER_URL = "https://goodvets.zendesk.com/hc/en-us";

export const MAX_DESCRIPTION_LENGTH = 1000;
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_PETS_SELECTION = 3;

export const ALLOWED_FILE_TYPES = ["application/pdf", "image/png", "image/jpeg"];
export const ALLOWED_FILE_EXTENSIONS = ".pdf,.png,.jpeg,.jpg";

export const COPY = {
  LANDING: {
    HEADING: "Find your answer in our\nSupport Center",
    DESCRIPTION:
      "Get all the answers on most frequently asked questions. If the answers are not helping, submit a support ticket by filling the fields below.",
    EXPLORE_BUTTON: "Explore Support Center",
    SECTION_HEADING: "Couldn\u2019t find an answer?",
    SECTION_DESCRIPTION: "Submit a ticket and we'll get back to you as soon as possible.",
    SUBMIT_BUTTON: "Submit Ticket",
  },
  STEPPER: {
    HEADING: "Customer Support",
    DESCRIPTION:
      "Fill the fields below and submit a ticket and we\u2019ll try to help as soon as possible.",
  },
  PET_SELECTION: {
    TITLE: "Select pets that this ticket is regarding",
    MAX_PETS_WARNING: `You can't select more than ${MAX_PETS_SELECTION} pets.`,
    CONTINUE: "Continue",
  },
  FORM: {
    SUBJECT_TITLE: "What is the main subject of your inquiry?",
    SUBJECT_SUBTITLE: "Select one of suggested subjects.",
    SUBJECT_PLACEHOLDER: "Select a subject",
    DESCRIPTION_TITLE:
      "Please provide a detailed description of your inquiry and what you may be experiencing.",
    DESCRIPTION_PLACEHOLDER: "Write detailed description...",
    UPLOAD_TITLE:
      "To enable us to better investigate this, please provide documentation.",
    UPLOAD_SUBTITLE: "This can include screenshot, photo, PDF.",
    UPLOAD_PLACEHOLDER: "Upload file",
    UPLOAD_SIZE_HINT: "File should be up to 10MB.",
    UPLOAD_SIZE_ERROR: "File exceeds the 10MB limit. Please upload a smaller file.",
    UPLOAD_TYPE_ERROR: "Invalid file type. Please upload a PNG, JPEG, or PDF file.",
    SUBMIT_BUTTON: "Submit Ticket",
  },
  INFO_BANNER:
   "Our support team works to respond to you within 2 business days. You will get an email with your ticket status and answers to your inquiry.",
  TOAST: {
    SUCCESS: "Your support ticket has been successfully submitted for a review.",
    ERROR: "Something went wrong. Please try again later.",
  },
} as const;
